import { Coordinate } from '@/Types/coordinate';
import { AccountType } from '@/Types/Enums/accountType';

export default class BusinessModel {

  businessId: string;
  businessName: string;
  businessAddress: string;
  coordinate: Coordinate;
  accountType: AccountType;

  constructor(serverModel: BusinessModel) {
    this.businessId = serverModel.businessId;
    this.businessName = serverModel.businessName;
    this.businessAddress = serverModel.businessAddress;
    this.coordinate = {
      latitude: serverModel.coordinate?.latitude,
      longitude: serverModel.coordinate?.longitude
    };
    this.accountType = serverModel.accountType;
  }
}
